import React, { useCallback, useEffect, useState } from 'react';
import {Route, useHistory} from 'react-router-dom';
import {SecureRoute, Security} from '@okta/okta-react';
import {OktaAuth} from '@okta/okta-auth-js';

import {ErrorBoundary, Navbar} from 'components';
import {CustomLoginCallback, DevicesList, EditDevice, ManufacturersList, ModelsList, FirmwaresList, EditFirmwareVersion, EditManufacturer, EditModel, Login, Tests} from 'pages';
import {axiosServer, DevicesService} from 'services';

const oktaAuth = new OktaAuth({
    // Note: If your app is configured to use the Implicit Flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to add `pkce: false`
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: window.location.origin + '/login/callback',
    // pkce: false,
});

export const oktaScopes = ['openid', 'email', 'profile'];

// Subscribe to changes in the auth state so that we can add the token to our headers after login.
// These must be set before rendering any component that loads data. This works
// because SecureRoute waits for authState to settle before rendering the route.
oktaAuth.authStateManager.subscribe((authState) => {
    const token = authState?.accessToken?.accessToken;

    if (token) {
        const headerVal = 'Bearer ' + token;
        axiosServer.defaults.headers.common['Authorization'] = headerVal;
    }
});

export function App(props) {
    const history = useHistory();

    const onAuthRequired = () => {
        history.push('/login');
    }

    // subscribe to auth change
    useEffect(() => {
        oktaAuth.authStateManager.subscribe(onChangeAuthState);
        return () => {
            oktaAuth.authStateManager.unsubscribe(onChangeAuthState);
        }
    });

    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const onChangeAuthState = useCallback((authState) => {
        setIsAuthenticated(true);
    }, []);

    // get devices once authenticated
    useEffect(() => {
        if (isAuthenticated) DevicesService.getDevices();
    }, [isAuthenticated]);

    return (
        <ErrorBoundary>
            <Security oktaAuth={oktaAuth} onAuthRequired={onAuthRequired}>
                <Navbar />
                <div className="mainContainer">
                    <Route path='/login/callback' exact component={CustomLoginCallback} />
                    <Route path='/login' exact component={Login} />
                    <SecureRoute path='/' exact component={DevicesList} />
                    <SecureRoute path='/devices/:id' exact component={EditDevice} />
                    <SecureRoute path='/devices/:id/tests' exact component={Tests} />
                    <SecureRoute path='/firmware-versions' exact component={FirmwaresList} />
                    <SecureRoute path='/firmware-versions/:id' exact component={EditFirmwareVersion} />
                    <SecureRoute path='/manufacturers' exact component={ManufacturersList} />
                    <SecureRoute path='/manufacturers/:id' exact component={EditManufacturer} />
                    <SecureRoute path='/models' exact component={ModelsList} />
                    <SecureRoute path='/models/:id' exact component={EditModel} />
                </div>
            </Security>
        </ErrorBoundary>
    );
}